export const API_REQUEST="DASHBOARD/API_REQUEST"
export const API_SUCCESS="DASHBOARD/API_SUCCESS"
export const API_ERROR  ="DASHBOARD/API_ERROR"
//api
export const API_STATS_REQUEST="DASHBOARD/API_STATS_REQUEST"
export const API_STATS_SUCCESS="DASHBOARD/API_STATS_SUCCESS"
export const API_STATS_ERROR  ="DASHBOARD/API_STATS_ERROR"
